
import React, { BaseSyntheticEvent } from 'react';
import { CQAppConstant } from '../../../../../app-constants';
import { CQMasterDataStore } from '../../../../../store/cq-master-data.store';
import { observer } from 'mobx-react';
import LayoutFieldsConfigController from '../../../layout-level-fields.controller';
import { CQAppStore } from '../../../../../store/cq-app-store';
import RuleComponent from './lookup-filter-components/rule-component';
import GroupComponent from './lookup-filter-components/group-component';
import { Utility } from '../../../../../common/utility';
import '../apply-rule-modal.css';

class LookupFilterRuleContainer extends React.Component<any, any> {
    private readonly layoutFieldsConfigCtrl: LayoutFieldsConfigController;
    private readonly cqUtilityClass: Utility;
    constructor(props: any) {
        super(props);
        this.cqUtilityClass = new Utility();
        this.layoutFieldsConfigCtrl = new LayoutFieldsConfigController();
        this.state = {
            rootGroup: {
                filters: [
                    {
                        field: '',
                        operator: '',
                        dynamicValue: '',
                        isDynamic: false,
                        selectedFieldType: ''
                    }
                ],
                logic: 'and'
            },
            selectedReferenceFields: [],
            lookupFields: []
        };
    }

    componentDidMount = async () => {
        if (this.props.appliedRule) {
            const ruleObject = CQMasterDataStore.RuleElements.FieldRuleElement;
            const objectName: any = this.props.objectName;
            const ruleElement = { ...(ruleObject[objectName])['lookupFilter'] };
            if (ruleElement) {
                let selectedReferenceFields: any[] | undefined = [];
                if (ruleElement.selectedReferenceFields) {
                    selectedReferenceFields = await this.layoutFieldsConfigCtrl.getLookFieldsDataInEditMode(ruleElement.selectedReferenceFields);                      
                    selectedReferenceFields = (selectedReferenceFields && selectedReferenceFields.length > 0) ? selectedReferenceFields : [];
                }
                               
                this.setState({
                    rootGroup: ruleElement.rootGroup,
                    selectedReferenceFields
                });
            }
        }
        try {           
            CQAppStore.loader.setVisibility(true);
            const lookupObjectFields = await this.layoutFieldsConfigCtrl.getLookupFields(this.props.referenceTo);
            if (lookupObjectFields.fields) {
                this.setState({ lookupFields: lookupObjectFields.fields });               
            }
            CQAppStore.loader.setVisibility(false);
        } catch (error : any) {
            this.props.toggleModalVisibility();
            CQAppStore.loader.setVisibility(false);
            const errorObj = {
                errorType: CQAppConstant.ERROR_CUSTOM,
                errorMessage: error.error ? error.error : error.message,
                errorStatus: error.status,
                componentName: ''
            };
            CQAppStore.error.dispatchError(errorObj);
        }
    }

    public render() {
        const layoutFields = this.layoutFieldsConfigCtrl.getLayoutFields(this.props.selectedTemplateName);
        return (
            <>
                <div className="slds-grid slds-grid_vertical full-height">
                    <div className="slds-expression">
                        <div className="slds-expression__options">
                            <div className="slds-form-element">
                                <h3 className="slds-m-bottom_small">Take Action When</h3>
                                <div className="slds-form-element__control">
                                    <div className="slds-select_container">
                                        <select role="lookfilter-condition-operators" className="slds-select"
                                            value={this.state.rootGroup.logic}
                                            onChange={e => this.updateLogicOperator(e, '0')}>
                                                <option value="">Please select</option>
                                            {
                                                CQAppConstant.LOOKFILTER_CONDITION_OPERATORS
                                                    .map((operator: { label: string, value: string }, index: number) => {
                                                        return (<option key={index} value={operator.value}>{`${operator.label} - ${operator.value}`}</option>);
                                                    })
                                            }
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <ul>
                            {
                                this.state.rootGroup.filters.length > 0 &&
                                this.state.rootGroup.filters.map((criteria: any, criteriaIndex: number) => {
                                    return (
                                        <React.Fragment key={criteriaIndex}>
                                            {
                                                (criteria.hasOwnProperty('field')) &&
                                                <RuleComponent ruleIndex={criteriaIndex.toString()}
                                                    ruleData={criteria} layoutFields={layoutFields}
                                                    lookupFields={this.state.lookupFields}
                                                    deleteCriteria={this.deleteCriteria}
                                                    updateRuleData={this.updateRuleData}
                                                    selectedReferenceFields={this.state.selectedReferenceFields}
                                                />
                                            }
                                            {
                                                (!criteria.hasOwnProperty('field')) &&
                                                <GroupComponent groupIndex={criteriaIndex.toString()}
                                                    groupData={criteria} layoutFields={layoutFields}
                                                    lookupFields={this.state.lookupFields}
                                                    addGroupedFilter={this.addGroupedFilter}
                                                    addCriteria={this.addCriteria}
                                                    deleteCriteria={this.deleteCriteria}
                                                    updateRuleData={this.updateRuleData}
                                                    updateLogicOperator={this.updateLogicOperator}
                                                    selectedReferenceFields={this.state.selectedReferenceFields} />
                                            }
                                        </React.Fragment>
                                    );
                                })
                            }
                        </ul >
                        <div className="slds-expression__buttons">
                            <button role="add-condition" className="slds-button slds-button_neutral"
                                onClick={() => {
                                    this.addCriteria();
                                }}>
                                <i className="cq-icon-add slds-m-right_x-small"></i> Add Condition</button>
                            <button role="add-group" className="slds-button slds-button_neutral"
                                onClick={() => {
                                    this.addGroupedFilter();
                                }}>
                                <i className="cq-icon-add slds-m-right_x-small"></i> Add Group</button>
                        </div>
                    </div >
                </div >
            </>
        );
    }



    /**
     * @private
     * @memberof LookupFilterRuleContainer
     */
    private addCriteria = (nodeName?: string) => {
        const rootGroup = this.cqUtilityClass.createObjectDeepCopy(this.state.rootGroup);
        const critetia = {
            field: '',
            operator: '',
            dynamicValue: '',
            isDynamic: false,
            selectedFieldType: ''
        };
        if (typeof nodeName === 'undefined') {
            let firstGroupIndex;
            rootGroup.filters.some((entry: any, i: number) => {
                if (entry.hasOwnProperty('filters')) {
                    firstGroupIndex = i;
                    return true;
                }
            });
            if (firstGroupIndex) {
                rootGroup.filters.splice(firstGroupIndex, 0, critetia);
            } else {
                rootGroup.filters.push(critetia);
            }
            this.setState({ rootGroup }, () => this.updateRuleObject(CQAppConstant.LOOKUP_FILTER, this.state));
        } else {
            this.appendData(nodeName, critetia);
        }
    }

    /**
     * @private
     * @memberof LookupFilterRuleContainer
     */
    private addGroupedFilter = (nodeName?: string) => {
        const groupedFilter = {
            filters: [
                {
                    field: '',
                    operator: '',
                    dynamicValue: '',
                    isDynamic: false,
                    selectedFieldType: ''
                }
            ],
            logic: 'and',
        };
        if (typeof nodeName === 'undefined') {
            const rootGroup = this.cqUtilityClass.createObjectDeepCopy(this.state.rootGroup);
            rootGroup.filters.push(groupedFilter);
            this.setState({ rootGroup }, () => this.updateRuleObject(CQAppConstant.LOOKUP_FILTER, this.state));
        } else {
            this.appendData(nodeName, groupedFilter);
        }
    }

    /**
     * @private
     * @memberof LookupFilterRuleContainer
     */
    private updateRuleObject = (ruleObjectProperty: string, ruleObjectValue: any) => {
        // const ruleObject: any = { ...this.props.ruleObject };
        // ruleObject[ruleObjectProperty] = ruleObjectValue;
        // if (this.state.rootGroup.logic && !ruleObject['logic']) {
        //     ruleObject['logic'] = this.state.rootGroup.logic;
        // }

        this.props.setRuleObject(ruleObjectValue);
        this.props.checkValidation(this.validateAddRuleForm());
    }


    /**
     * @private
     * @memberof LookupFilterRuleContainer
     */
    private validateAddRuleForm = () => {
        let isCriteriaValid = true;
        isCriteriaValid = this.state.rootGroup.filters.every((criteria: any) => {
            return this.validateGroupData(criteria);
        });
        if (!isCriteriaValid || this.state.rootGroup.logic === '') {
            return true;
        }
        return false;
    }

    private validateGroupData = (filtersData: any): boolean => {
        let isValidData = true;
        if (filtersData.hasOwnProperty('field')) {
            isValidData = (filtersData.field !== '' && filtersData.operator !== '' && filtersData.dynamicValue !== '');
        } else if (!filtersData.hasOwnProperty('field')) {
            if (filtersData.logic === '') {
                return false;
            }
            for (const groupCriteria of filtersData.filters) {
                if (groupCriteria.hasOwnProperty('field')) {
                    isValidData = (groupCriteria.field !== '' && groupCriteria.operator !== '' && groupCriteria.dynamicValue !== '');
                    if (!isValidData) {
                        break;
                    }
                } else if (!filtersData.hasOwnProperty('field')) {
                    isValidData = groupCriteria.logic === '' ? false : this.validateGroupData(groupCriteria);
                }

            }
        }
        return isValidData;
    }

    /**
    * @private
    * @memberof LookupFilterRuleContainer
    */
    private appendData = (nodeName: string, criteria: any) => {
        const rootGroup = this.cqUtilityClass.createObjectDeepCopy(this.state.rootGroup);
        let nodeFilters: any = rootGroup.filters;
        const nodeArray = nodeName.split('/');
        if (nodeName !== '0') {
            nodeArray.forEach((nodeIndex: string, index: number) => {
                nodeFilters = this.getNodeData(nodeFilters, nodeIndex);
            });
        }
        let firstGroupIndex;
        nodeFilters.some((entry: any, i: number) => {
            if (entry.hasOwnProperty('filters')) {
                firstGroupIndex = i;
                return true;
            }
        });
        if (firstGroupIndex) {
            nodeFilters.splice(firstGroupIndex, 0, criteria);
        } else {
            nodeFilters.push(criteria);
        }        
        this.setState({ rootGroup }, () => this.updateRuleObject(CQAppConstant.LOOKUP_FILTER, this.state));
    }

    /**
    * @private
    * @memberof LookupFilterRuleContainer
    */
    private deleteCriteria = (nodeName: string) => {
        const rootGroup = this.cqUtilityClass.createObjectDeepCopy(this.state.rootGroup);
        let nodeFilters: any = rootGroup.filters;

        const nodeArray = nodeName.split('/');

        nodeArray.forEach((nodeIndex: string, index: number) => {
            if (nodeArray.length === index + 1) {
                nodeFilters.splice(parseInt(nodeIndex), 1);


            } else {
                nodeFilters = this.getNodeData(nodeFilters, nodeIndex);
            }
        });
        this.setState({ rootGroup }, () => this.updateRuleObject(CQAppConstant.LOOKUP_FILTER, this.state));
    }

    /**
    * @private
    * @memberof LookupFilterRuleContainer
    */
    private readonly updateRuleData = (e: BaseSyntheticEvent, nodeName: string, fieldName: string, isBooleanValue: boolean) => {
        const rootGroup = this.cqUtilityClass.createObjectDeepCopy(this.state.rootGroup);
        let nodeFilters: any = rootGroup.filters;
        const nodeArray = nodeName.split('/');
        nodeArray.forEach((nodeIndex: string, index: number) => {
            if (nodeArray.length === index + 1) {
                let criteriaData = nodeFilters[parseInt(nodeIndex)];
                this.setSelectedFieldType(criteriaData);
                if (fieldName === 'isDynamic') {
                    criteriaData[fieldName] = e.target.checked;
                    criteriaData['dynamicValue'] = '';
                } else {
                    criteriaData[fieldName] = isBooleanValue ? e.target.checked : e.target.value;
                }
                if (fieldName === 'field') {
                    criteriaData = this.deleteReferenceKeys(criteriaData);
                    const selectedFieldType = this.state.lookupFields.filter((field: any) => field.name === criteriaData[fieldName]);
                    criteriaData.selectedFieldType = (selectedFieldType[0].scale === 0 && selectedFieldType[0].type === 'double') ? 'integer' : selectedFieldType[0].type;
                    criteriaData['dynamicValue'] = criteriaData.selectedFieldType === 'boolean' ? false : '';
                    this.setReferenceFieldIfSelected(criteriaData, selectedFieldType[0].referenceTo[0], criteriaData[fieldName]);
                }

            } else {
                nodeFilters = this.getNodeData(nodeFilters, nodeIndex);
            }
        });


        this.setState({ rootGroup }, () => this.updateRuleObject(CQAppConstant.LOOKUP_FILTER, this.state));
    }

    /**
    * @private
    * @memberof LookupFilterRuleContainer
    */
    private updateLogicOperator = (e: BaseSyntheticEvent, nodeName: string) => {
        const rootGroup = this.cqUtilityClass.createObjectDeepCopy(this.state.rootGroup);
        if (nodeName !== '0') {
            let nodeFilters: any = rootGroup.filters;
            const nodeArray = nodeName.split('/');
            nodeArray.forEach((nodeIndex: string, index: number) => {
                if (nodeArray.length === index + 1) {
                    nodeFilters[parseInt(nodeIndex)].logic = e.target.value;
                } else {
                    nodeFilters = this.getNodeData(nodeFilters, nodeIndex);
                }
            });

            this.setState({ rootGroup }, () => this.updateRuleObject(CQAppConstant.LOOKUP_FILTER, this.state));
        } else {
            rootGroup.logic = e.target.value;
            this.setState({ rootGroup }, () => this.updateRuleObject('logic', this.state));
        }
    }

    /**
     * @private
     * @memberof LookupFilterRuleContainer
     */
    private readonly getNodeData = (nodeData: any, nodeIndex: string) => {
        return nodeData[parseInt(nodeIndex)].filters;
    }

    /**
     * @private
     * @memberof LookupFilterRuleContainer
     */
    private readonly setSelectedFieldType = (criteriaData: any) => {
        if (criteriaData['field'] !== '') {
            const selectedFieldType = this.state.lookupFields.filter((field: any) => field.name === criteriaData['field']);
            criteriaData.selectedFieldType = (selectedFieldType[0].scale === 0 && selectedFieldType[0].type === 'double') ? 'integer' : selectedFieldType[0].type;
        }
        return criteriaData;
    }


    /**
     * @private
     * @memberof LookupFilterRuleContainer
     */
    private readonly setReferenceFieldIfSelected = async (criteriaData: any, refernceFieldName: string, fieldName: string) => {
        
        
        if (criteriaData.selectedFieldType === 'reference') {

            const selectedReferenceFields = [...this.state.selectedReferenceFields];
            const selectedReferenceFieldsCopy = selectedReferenceFields.map((referenceField: any) => {
                return { 'fieldName': referenceField.fieldName, 'refernceFieldName': referenceField.refernceFieldName };
            });
            const hasReferenceFieldDetails = selectedReferenceFields.some((selectedReferenceField: any) => selectedReferenceField.fieldName === fieldName);
            if (!hasReferenceFieldDetails) {
                CQAppStore.loader.setVisibility(true);
                await this.layoutFieldsConfigCtrl.getLookupFields(refernceFieldName).then((lookupFields: any) => {
                    selectedReferenceFieldsCopy.push({ fieldName, refernceFieldName });
                    selectedReferenceFields.push({ fieldName, refernceFieldName, relatedFields: lookupFields.fields });
                    
                    this.setState({ selectedReferenceFields }, () => this.updateRuleObject(CQAppConstant.LOOKUP_FILTER_SELECTED_REFERENCE_FIELDS, this.state));
                    CQAppStore.loader.setVisibility(false);
                }).catch((error : any) => {
                    this.props.toggleModalVisibility();
                    CQAppStore.loader.setVisibility(false);
                    const errorObj = {
                        errorType: CQAppConstant.ERROR_CUSTOM,
                        errorMessage: error.error ? error.error : error.message,
                        errorStatus: error.status,
                        componentName: ''
                    };
                    CQAppStore.error.dispatchError(errorObj);
                });
            }
        }
    }

    /**
     * @private
     * @memberof LookupFilterRuleContainer
     */
    private readonly deleteReferenceKeys = (criteriaData: any) => {
        if (criteriaData.hasOwnProperty('usv_function')) {
            delete criteriaData['usv_function'];
        }
        if (criteriaData.hasOwnProperty('usv_param')) {
            delete criteriaData['usv_param'];
        }
        if (criteriaData.hasOwnProperty('referenceField')) {
            delete criteriaData['referenceField'];
        }
        return criteriaData;
    }


}
export const LookupFilterRule = observer(LookupFilterRuleContainer);
